<project-details-breadcrumb-header *ngIf="project != null"
  [project]="project"
  [title]="'PREVIEW & NOTES'"
  [breadcrumbs]="breadcrumbs"
></project-details-breadcrumb-header>
<div class="loader" [hidden]="status != STATUS_LOADING">
  <div class="dimmed ">
      <div class="dimmed_title long"></div>
  </div>
</div>

  <!-- ATTACHMENTS -->
  <div *ngIf="status == STATUS_DONE" class="project-details-file-preview">
    <core-files-list-default-item
        [file]="file"
        [menu]="menu"
        (menuClick)="onMenuClick($event)"
        (iconDownloadClick)="onActionDownloadClick($event)"
    ></core-files-list-default-item>
    <article>
        <core-file-notes
            [file]="file"
            [urlPrefix]="notesUrlPrefix"
            [canCreateNotes]="canCreateNotes"
            (saved)="notesSaved($event)"
        ></core-file-notes>
    </article>
  </div >
